import * as Yup from 'yup'

// everything including words and numbers except ", : ; *"
const allButThese = /[^,:;*]+$/;

export const formValidation = Yup.object().shape({
  businessName: Yup.string().matches(allButThese, 'no special characters allow').required('Required'),
  email: Yup.string().email('Invalid Email').required('Required'),
})
